module.exports = __webpack_public_path__ + "static/media/truck-icon-keyon.829338b9.svg";